import { createAction } from "typesafe-actions";

import { ViewActionType } from "./constants";
import type { IToggleOverlayMenuParams, SyncNestedNodesWithMobileParams } from "./types";

export const toggleFlyout = createAction(ViewActionType.TOGGLE_FLYOUT, (params: IToggleOverlayMenuParams) => params)();

export const closeFlyout = createAction(ViewActionType.CLOSE_FLYOUT)();

export const syncNestedFlyoutNodesWithMobile = createAction(
  ViewActionType.SYNC_NESTED_NODES_WITH_MOBILE,
  (params: SyncNestedNodesWithMobileParams) => params
)();
